import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import Flag from './flag'

const flags = ['en', 'ru', 'fr', 'de']    
    
const Flags: React.FunctionComponent<{className?: string}> = ({ className }) => (
    <Container className={className} >
        { flags.map(key => <Flag key={key} lang={key} />)}
    </Container>
)

const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(${flags.length}, 1fr);

    grid-column-gap: 16px;

    ${up('tablet')} {
        grid-column-gap: 18px;
    }
`

export default Flags
